/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useState} from 'react';
import {Button, Form, FormInstance, Input, List} from "antd";
import {CheckOutlined} from "@ant-design/icons";
import styles from './WorkLocInput.module.scss';
import geoAPI from "../../../../../api/geoAPI";

interface WorkLocInputProps {
	form: FormInstance;
}

const WorkLocInput = ({form}: WorkLocInputProps) => {
	const workLoc = Form.useWatch('workLoc', form);

	const [results, setResults] = useState<string[]>([]);
	const [loading, setLoading] = useState(false);
	const [isCheck, setIsCheck] = useState(false);

	const handleGeoData = async (str: any) => {
		const res = await geoAPI.fetchRegions(str);
		const {region, selectedRegion, selectedRegionLat, selectedRegionLon} = res;

		if (selectedRegion && region.length === 0) {
			form.setFieldValue('region', selectedRegion);
			form.setFieldValue('latitude', selectedRegionLat);
			form.setFieldValue('longitude', selectedRegionLon);
			setResults([selectedRegion]);
			setIsCheck(true);
		} else {
			setResults(region);
		}
	};

	const onSearch = async () => {
		if (!workLoc) return;

		setLoading(true);
		setIsCheck(false);
		try {
			await handleGeoData(workLoc);
		} catch (e) {
			console.error(e);
		} finally {
			setLoading(false);
		}
	};

	const onSelectRegion = async (item: string) => {
		if (!item) return;

		setLoading(true);
		setIsCheck(false);
		try {
			await handleGeoData(item);
		} catch (e) {
			console.error(e);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className={styles.wrap}>
			<Form.Item name="region" hidden><Input /></Form.Item>
			<Form.Item name="latitude" hidden><Input /></Form.Item>
			<Form.Item name="longitude" hidden><Input /></Form.Item>

			<div style={{display: 'flex', alignItems: 'center', gap: '20px'}}>
				<Form.Item
					name="workLoc"
					label="주소"
					rules={[{required: true, message: '현장 주소를 입력하세요'}]}
					style={{padding: 0, margin: 0}}
				>
					<Input
						placeholder="신정동, 문정동"
						onPressEnter={(e) => {
							e.preventDefault();
							e.stopPropagation();
							onSearch();
						}}
					/>
				</Form.Item>

				<Button onClick={onSearch} loading={loading}>
					검색
				</Button>
			</div>

			{/* 검색 결과 리스트 */}
			<div>
				<List
					className={styles.resultList}
					dataSource={results}
					renderItem={(item) => (
						<List.Item
							className={styles.item}
							onClick={() => onSelectRegion(item)}
						>
							{item}
							{isCheck && <CheckOutlined style={{ color: 'green'}} />}
						</List.Item>
					)}
				/>
			</div>
		</div>
	);
};

export default WorkLocInput;